import graphql from 'babel-plugin-relay/macro'
import md5 from 'md5'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { createFragmentContainer } from 'react-relay'
import styled from 'styled-components'

import config from '../../config'
import socket from '../../socket'

const Container = styled.div`
  display: flex;
  padding: 12px 16px;
  border-bottom: 1px solid #f3f3f3;
  align-items: center;
  background-color: #FAFAFA;
`

const Title = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 1.2em;
  font-weight: bold;
`

const UserTyping = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 0.8em;
  color: gray;
`

const HeaderDetails = styled.div`
  margin-left: 16px;
  flex: 1;
`

const Avatar = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 32px;
  background-size: 64px 64px;
  float: left;
  margin-top: 4px;
`

class ConversationHeader extends Component {
  state = {
    participantTyping: undefined
  }

  componentDidMount () {
    socket.on('typing', this.onSocketTyping)
  }

  componentWillUnmount () {
    socket.removeListener('typing', this.onSocketTyping)
  }

  onSocketTyping = data => {
    const { conversation: { id, participants } = {} } = this.props
    if (data.conversationId !== id) return
    if (data.charactersCount === 0 && this.state.participantTyping) return this.setState({ participantTyping: undefined })

    const participant = participants && participants.edges.find(e => e.node.user && e.node.user.id === data.userId)

    this.setState({
      participantTyping: (participant && participant.node && participant.node.user),
      participantTypingLength: data.charactersCount
    })
  }

  renderParticipantTyping = () => {
    const { participantTyping } = this.state
    if (!participantTyping) return null

    return (
      <UserTyping>{this.props.t('conversation_user_is_typing', { firstName: participantTyping.firstName })}</UserTyping>
    )
  }

  renderPictureUrl = ({ id, pictureUrl }) => {
    if (!pictureUrl) return null

    const basename = url => url ? url.replace(/http?s:\/\/[^/]*\//, '') : ''
    
    const imageUrl = pictureUrl
      // ? `https://${config.imgixHost}/${pictureUrl.substr(pictureUrl.lastIndexOf('/') + 1)}?w=64&h=64&fit=crop&mask=ellipse&dpr=2&fm=png32`
      ? `https://${config.cloudimageHost}/${basename(pictureUrl)}?width=64&height=64&func=crop&optipress=1`
      : `${config.apiUrl}/avatar/${md5(id.trim().toLowerCase())}?s=64`

    return <Avatar style={{ backgroundImage: `url(${imageUrl})` }} />
  }

  render () {
    const { conversation, conversation: { displayTitle, displaySubtitle, description, type, shortId, pictureUrl } } = this.props

    return (
      <Container>
        {this.renderPictureUrl({ id: shortId, pictureUrl })}
        <HeaderDetails>
          <Title>{displayTitle || type}</Title>
          {this.renderParticipantTyping() || description || displaySubtitle}
        </HeaderDetails>
      </Container>
    )
  }
}

const ConversationHeaderContainer = createFragmentContainer(ConversationHeader, {
  conversation: graphql`
    fragment ConversationHeader_conversation on Conversation {
      id
      displayTitle
      displaySubtitle
      description
      type
      shortId
      pictureUrl
      participants: participantsByConversationId(first: 666) {
        edges {
          node {
            user: userByUserId {
              id
              firstName
              lastName
              pictureUrl
            }
            family: familyByFamilyId {
              id
              name
            }
            contact: contactByContactId {
              id
              firstName
              lastName
              pictureUrl
              email
              phone
            }
            partner: partnerByPartnerId {
              id
              name
            }
          }
        }
      }
    }
  `
})

const TranslatedConversationHeaderContainer = withTranslation()(ConversationHeaderContainer)
export { TranslatedConversationHeaderContainer as ConversationHeader }
